import store from 'shared/store'
import loadCatalogs from 'views/containers/browser/utils/loadCatalogs'
import buildClientAPI from 'views/providers/clientAPI'

const loadBuyBoxSendEmail = async () => {
  const container = document.getElementById('email-on-availability-box')

  const {
    publicConfig: { locale },
  } = store.getPublicRuntimeConfig()
  const catalogs = await loadCatalogs(locale)

  const { reavailabilityService } = buildClientAPI()

  const { default: hydrateComponent } = await import(
    /* webpackChunkName: "BuyBoxNotifyFormContainerWithRender",
    webpackPrefetch: true */
    `./BuyBoxEmailFormContainerWithRender`
  )

  await hydrateComponent({
    locale,
    container,
    catalogs,
    api: { reavailabilityService },
  })
}

export default async () => {
  await loadBuyBoxSendEmail()
}
